import type { ReactElement } from 'react';
import { formatTotalsToHoursMinutes } from '../helpers/TimeSpanHelper';

export type TotalTimeCardProps = {
  value: string | number;
  label?: string;
  infoIcon: ReactElement;
};

const TotalTimeCard = ({ value, infoIcon, label }: TotalTimeCardProps) => (
  <div className="total-time-card">
    <div className="card-body">
      <div className="card-title">
        <div className="card-info-icon">{infoIcon}</div>
        <div className="card-title-text">{label ?? 'Total Time'}</div>
      </div>
      <p className="card-time">{formatTotalsToHoursMinutes(value)}</p>
    </div>
  </div>
);

export default TotalTimeCard;
